'use strict';

var ManagerActions = function ManagerActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('ManagerActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'Changed',
    purpose: 'A processing job has been updated',
    payload: ['jobId']
  });

  Actions.add({
    name: 'OpenDialog',
    purpose: 'Open dialog with instruction',
    payload: ['view', 'data']
  });

  Actions.add({
    name: 'CloseDetailView',
    purpose: 'Go back to the overview view',
    payload: ['']
  });

  Actions.add({
    name: 'OpenDetailView',
    purpose: 'Alerts overview that detail view is open',
    payload: ['']
  });

  Actions.add({
    name: 'DeleteDataSet',
    purpose: 'Indicates confirmation for deleting a dataset',
    payload: ['jobId']
  });

  return Actions;
};

ManagerActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = ManagerActions;



// WEBPACK FOOTER //
// ./src/app/manager/ManagerActions.js